<template>
  <div class="pb-4">
    <Links
      class="flex items-center justify-center bottom-block"
      style="box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);"
      :category="category"
    >
      <a
        slot="link"
        slot-scope="{ link, icon, text, isSelected }"
        class="bottom-block__link"
        :class="[{ 'bottom-block__link--selected': isSelected($route.path)}]"
        :href="link"
      >
        <component :is="icon" />

        <div class="link__text">
          {{ text }}
        </div>
      </a>
    </Links>
  </div>
</template>

<script>
import Links from "../links";

export default {
  props: {
    category: {
      type: String,
      default: () => null,
    }
  },

  components: {
    Links,
  },
}
</script>

<style scoped>
.bottom-block {
  height: 50px;
  @apply bg-primary-dark-purple;
}

.bottom-block__link {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
  font-size: 14px;

  @apply text-gray-100;
}

.bottom-block__link--selected {
  background: #4d4d4d;
}

.bottom-block__link:not(.bottom-block__link--selected):hover {
  @apply bg-p5;
}

.link__text {
  margin-left: 10px;
}

</style>
